<template>
    <div v-bind:class="listClass">
        <v-container fluid>
            <v-row dense class="drag-element-list">
                <template v-for="(element, key) in elements">
                    <listElement v-if="useLegacyElements || element.legacy===false"
                                 :element="element"
                                 :view-privilege="true"
                                 :edit-privilege="false"
                                 :delete-privilege="false"
                                 :small="true"
                                 mode="tiles"
                                 :key="key"
                                 :element-class="elementClass"
                                 :drag-drop="true">
                    </listElement>
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import listElement from "./elementElementTile.vue";

    export default {
        props: [
            'classes',
            'elementClass',
            'useLegacyElements'
        ],
        components: {
            listElement,
        },
        computed: {
            listClass: function () {
                return this.classes + ' col-md-12';
            },
        },
        data: function () {
            return {
                t_new: Lang.langGet("New"),
                t_validity: Lang.langGet("Validity"),
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                elements: [
                    {
                        type: 'text',
                        eicon: 'text',
                        name: Lang.langGet("Text"),
                        legacy: false,
                    },
                    {
                        type: 'iframe',
                        eicon: 'web',
                        name: Lang.langGet("Web"),
                        legacy: false,
                    },
                    {
                        type: 'youtube',
                        eicon: 'youtube',
                        name: Lang.langGet("YouTube"),
                        legacy: true,
                    },
                    {
                        type: 'countdown',
                        eicon: 'countdown',
                        name: Lang.langGet("Countdown"),
                        legacy: true,
                    },
                    {
                        type: 'qrcode',
                        eicon: 'qrcode',
                        name: Lang.langGet("QR Code"),
                        legacy: true,
                    },
                    {
                        type: 'emptyrectangle',
                        eicon: 'empty-rectangle',
                        name: Lang.langGet("Empty Rectangle"),
                        legacy: false,
                    },
                    {
                        type: 'clock',
                        eicon: 'clock',
                        name: Lang.langGet("Clock"),
                        legacy: true,
                    },
                    {
                        type: 'day',
                        eicon: 'day',
                        name: Lang.langGet("Day"),
                        legacy: true,
                    },
                    {
                        type: 'weather',
                        eicon: 'weather',
                        name: Lang.langGet("Weather"),
                        legacy: true,
                    },
                    {
                        type: 'layer',
                        eicon: 'layer',
                        name: Lang.langGet("Layer"),
                        legacy: false,
                    },
                    {
                        type: 'esign',
                        eicon: 'esign',
                        name: Lang.langGet("eSign"),
                        legacy: false,
                    },
                    {
                        type: 'rssfeed',
                        eicon: 'rss',
                        name: Lang.langGet("RSS Feed"),
                        legacy: false,
                    },
                    {
                        type: 'streaming',
                        eicon: 'streaming',
                        name: Lang.langGet("Streaming"),
                        legacy: false,
                    }
                ]
            }
        },
    }
</script>
